import { Grid, TextField, Button, Divider, useTheme, useMediaQuery } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/CleaningServices";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";

export default function SearchFormGenerico({
    columns,
    initialValues = {},
    onChange,
    onSearch,
    onClose
}) {
    const [values, setValues] = useState(initialValues);

    // 🔁 Rehidratar valores si vienen del padre
    useEffect(() => {
        setValues(initialValues || {});
    }, [initialValues]);

    const handleChange = (field, value) => {
        const newValues = {
            ...values,
            [field]: value
        };

        setValues(newValues);
        onChange?.(newValues);
    };

    const handleSubmit = () => {
        const condiciones = Object.entries(values)
            .filter(([_, value]) => value !== "" && value !== null)
            .map(([field, value]) => ({
                propiedad: field,
                operador: "LIKE",
                valor: value
            }));

        onSearch(condiciones);
    };

    const handleClear = () => {
        setValues({});
        onChange?.({});
        onSearch([]);
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Grid container spacing={2}>
            {/* Campos */}
            {columns
                .filter(col => col.field !== "id" && col.field !== "actions")
                .map(col => (
                    <Grid item xs={12} md={6} key={col.field}>
                        <TextField
                            fullWidth
                            size="small"
                            label={col.headerName}
                            value={values[col.field] || ""}
                            onChange={(e) =>
                                handleChange(col.field, e.target.value)
                            }
                        />
                    </Grid>
                ))}

            <Grid item xs={12}>
                <Divider sx={{ my: 1 }} />
            </Grid>

            {/* Acciones */}
            <Grid
                item
                xs={12}
                display="flex"
                flexDirection={isMobile ? "column-reverse" : "row"}
                justifyContent="space-between"
                alignItems="center"
                gap={isMobile ? 2 : 0}
            >
                <Button
                    onClick={handleClear}
                    color="warning"
                    variant="outlined"
                    startIcon={<ClearIcon />}
                    size="small"
                    fullWidth={isMobile}
                >
                    Limpiar
                </Button>

                <Grid display="flex" gap={1} flexDirection={isMobile ? "column" : "row"} width={isMobile ? "100%" : "auto"}>
                    <Button
                        onClick={onClose}
                        color="error"
                        variant="contained"
                        startIcon={<CloseIcon />}
                        size="small"
                        fullWidth={isMobile}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<SearchIcon />}
                        onClick={handleSubmit}
                        size="small"
                        fullWidth={isMobile}
                    >
                        Buscar
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}
